module.exports = __webpack_public_path__ + "e1b3a668d36becd42fce8ce00277ab4d.svg";